import './publicPath'

const Vue = window.Vue

Vue.component('FeedGalleryModal', () => import( "./components/Feed4CeresGallery.vue"))
Vue.component('FeedCarouselModal', () => import( "./components/Feed4CeresCarousel.vue"))